var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultipleUsers(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.3892 1.61719C3.83369 1.61719 2.57271 2.94823 2.57271 4.59015C2.57271 6.01557 3.52307 7.20668 4.79145 7.49602V7.60512C3.81695 7.74277 2.90566 8.21432 2.2027 8.95633C1.35759 9.84839 0.882812 11.0583 0.882812 12.3198",
    stroke: "#77789D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83536 7.63014C11.6662 7.63014 13.1504 6.14593 13.1504 4.31507C13.1504 2.48421 11.6662 1 9.83536 1C8.0045 1 6.52029 2.48421 6.52029 4.31507C6.52029 6.14593 8.0045 7.63014 9.83536 7.63014ZM9.83536 7.63014C11.2421 7.63014 12.5912 8.18896 13.5859 9.18368C14.5806 10.1784 15.1395 11.5275 15.1395 12.9343H4.53125C4.53125 11.5275 5.09007 10.1784 6.08479 9.18368C7.0795 8.18896 8.42862 7.63014 9.83536 7.63014Z",
    stroke: "#2E2F43",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2827 1.61719C15.8382 1.61719 17.0992 2.94823 17.0992 4.59015C17.0992 6.01557 16.1488 7.20668 14.8804 7.49602V7.60512C15.8549 7.74277 16.7662 8.21432 17.4692 8.95633C18.3143 9.84839 18.7891 11.0583 18.7891 12.3198",
    stroke: "#77789D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleUsers);
export default __webpack_public_path__ + "static/media/multipleUsers.c8ea4ad682d145f7cc7b7910a957c8c6.svg";
export { ForwardRef as ReactComponent };